<template>
  <cookie-consent
      message="Vi bruger cookies - lige som alle de andre."
  >
    <template slot="link">
      &nbsp;<router-link to="/cookies">Læs mere her</router-link>
      .&nbsp;
    </template>
    <template slot="button">
      <button class="btn btn-info btn-sm">Acceptér</button>
    </template>
  </cookie-consent>

</template>

<script>
import CookieConsent from 'vue-cookieconsent-component'

export default {
  components: {CookieConsent},
  name: "Cookies"
}
</script>

<style lang="scss" scoped>
$cookieconstent-background: #ee964b !default;

@import "~vue-cookieconsent-component/src/scss/cookie-consent";
@import "~vue-cookieconsent-component/src/scss/cookie-consent-bottom";
@import "~vue-cookieconsent-component/src/scss/cookie-consent-transition";
</style>
